// Mock data for MaPrimeRénov' 2026 Landing Page

export const siteConfig = {
  name: "MaPrimeRénov'",
  tagline: "Aides à la Rénovation Énergétique 2026",
  gtmId: "GTM-XXXXXX",
};

export const categories = [
  {
    id: 'ITE',
    title: 'Isolation Thermique Extérieure',
    subtitle: 'ITE',
    description: 'Passoires énergétiques E/F/G : 75 à 100 €/m² d\'aides disponibles + bonus combles.',
    aidRange: '75 – 100 €/m²',
    icon: 'Building2',
    cta: 'Qualifier mon projet ITE',
    borderColor: 'border-teal-200',
    iconBg: 'bg-teal-100',
    iconColor: 'text-teal-700',
    accentColor: 'bg-teal-50',
  },
  {
    id: 'PAC',
    title: 'Pompe à Chaleur',
    subtitle: 'PAC',
    description: 'Remplacement de chaudière : de 5 000 € à 15 000 € d\'aides selon vos revenus.',
    aidRange: '5 000 – 15 000 €',
    icon: 'Flame',
    cta: 'Qualifier mon projet PAC',
    borderColor: 'border-orange-200',
    iconBg: 'bg-orange-100',
    iconColor: 'text-orange-600',
    accentColor: 'bg-orange-50',
  },
  {
    id: 'PV',
    title: 'Panneaux Photovoltaïques',
    subtitle: 'PV',
    description: 'Installation toiture : prime à l\'autoconsommation + tarif de rachat garanti.',
    aidRange: 'Prime + Rachat',
    icon: 'Sun',
    cta: 'Qualifier mon projet PV',
    borderColor: 'border-amber-200',
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-600',
    accentColor: 'bg-amber-50',
  },
];

export const formSteps = {
  common: [
    {
      id: 'status',
      type: 'MULTI_CHOICE',
      label: 'Quel est votre statut ?',
      choices: ['Propriétaire occupant', 'Bailleur'],
    },
    {
      id: 'rfr',
      type: 'NUMBER',
      label: 'Revenu Fiscal de Référence 2024 (€)',
      placeholder: 'Ex : 25 000',
    },
    {
      id: 'postal',
      type: 'SHORT_TEXT',
      label: 'Code postal du logement',
      placeholder: 'Ex : 75001',
    },
    {
      id: 'dpe',
      type: 'MULTI_CHOICE',
      label: 'Quel est votre DPE actuel ?',
      choices: ['E', 'F', 'G', 'Je ne sais pas'],
    },
  ],
  ITE: [
    {
      id: 'combles',
      type: 'MULTI_CHOICE',
      label: 'Isolation des combles également ?',
      choices: ['Oui', 'Non'],
    },
    {
      id: 'surface_isoler',
      type: 'NUMBER',
      label: 'Surface à isoler (m²)',
      placeholder: 'Ex : 120',
    },
  ],
  PAC: [
    {
      id: 'chauffage_actuel',
      type: 'MULTI_CHOICE',
      label: 'Votre chauffage actuel ?',
      choices: ['Fioul', 'Gaz', 'Électrique', 'Autre'],
    },
    {
      id: 'surface_chauffee',
      type: 'NUMBER',
      label: 'Surface chauffée (m²)',
      placeholder: 'Ex : 100',
    },
  ],
  PV: [
    {
      id: 'surface_toiture',
      type: 'NUMBER',
      label: 'Surface toiture disponible (m²)',
      placeholder: 'Ex : 40',
    },
    {
      id: 'ombrage',
      type: 'MULTI_CHOICE',
      label: "Y a-t-il de l'ombrage sur votre toiture ?",
      choices: ['Aucun ombrage', 'Ombrage partiel', 'Ombrage important'],
    },
  ],
  contact: [
    {
      id: 'email',
      type: 'EMAIL',
      label: 'Votre adresse email',
      placeholder: 'exemple@email.com',
    },
    {
      id: 'phone',
      type: 'PHONE',
      label: 'Votre numéro de téléphone',
      placeholder: '06 12 34 56 78',
    },
  ],
};

export const trustBadges = [
  { icon: 'Clock', text: '2 min chrono' },
  { icon: 'ShieldCheck', text: '100% Gratuit' },
  { icon: 'CheckCircle', text: 'Certifié RGE' },
];

export const stats = [
  { value: '80%', label: 'Aides max.' },
  { value: '2 min', label: 'Vérification' },
  { value: '15 000+', label: 'Foyers aidés' },
];

export const footerData = {
  legal: [
    { label: 'Mentions légales', href: '/mentions-legales' },
    { label: 'Politique de confidentialité', href: '/confidentialite' },
    { label: 'CGU', href: '/mentions-legales' },
  ],
  resources: [
    { label: "Guide MaPrimeRénov' 2026", href: '#faq' },
    { label: "Simulateur d'aides", href: '#categories' },
    { label: 'FAQ', href: '#faq' },
  ],
};

// GTM tracking utility
export const trackEvent = (eventName, data = {}) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...data });
  }
};

// Google Ads conversion - called after lead is saved in DB
export const trackConversion = (conversionType, data = {}) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: conversionType,
      ...data,
    });
  }
};

// ── AdsTech: capture UTM, gclid, referrer on page load ─────────
export const captureTrafficSource = () => {
  if (typeof window === 'undefined') return {};

  const params = new URLSearchParams(window.location.search);
  const data = {};

  // Google Ads click ID
  const gclid = params.get('gclid');
  if (gclid) data.gclid = gclid;

  // Meta Ads click ID
  const fbclid = params.get('fbclid');
  if (fbclid) data.fbclid = fbclid;

  // Bing Ads click ID
  const msclkid = params.get('msclkid');
  if (msclkid) data.msclkid = msclkid;

  // UTM parameters
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((key) => {
    const val = params.get(key);
    if (val) data[key] = val;
  });

  // Landing page + referrer
  data.landing_page = window.location.pathname + window.location.search;
  if (document.referrer) data.referrer = document.referrer;
  data.user_agent = navigator.userAgent;

  // Persist in sessionStorage (survives page navigations within session)
  const existing = JSON.parse(sessionStorage.getItem('traffic_source') || '{}');
  // First-touch: don't overwrite existing gclid/utm if already captured
  const merged = { ...data, ...existing };
  // But always update if new gclid comes in (new click)
  if (gclid) merged.gclid = gclid;
  sessionStorage.setItem('traffic_source', JSON.stringify(merged));

  return merged;
};

export const getTrafficSource = () => {
  if (typeof window === 'undefined') return {};
  return JSON.parse(sessionStorage.getItem('traffic_source') || '{}');
};

// Testimonials
export const testimonials = [
  {
    name: 'Marie L.',
    location: 'Lyon (69)',
    project: 'ITE',
    text: "J'ai obtenu 12 000 € d'aides pour l'isolation de ma maison. Le conseiller m'a accompagnée de A à Z, je n'ai eu qu'à signer.",
    score: 92,
  },
  {
    name: 'Jean-Pierre D.',
    location: 'Bordeaux (33)',
    project: 'PAC',
    text: "Remplacement de ma chaudière fioul par une pompe à chaleur avec 11 000 € de prise en charge. Travaux terminés en 3 semaines.",
    score: 88,
  },
  {
    name: 'Sophie M.',
    location: 'Nantes (44)',
    project: 'PV',
    text: "Installation panneaux solaires financée à 60%. Ma facture d'électricité a baissé de moitié. Je recommande vivement.",
    score: 85,
  },
];

// FAQ
export const faqItems = [
  {
    question: "Qu'est-ce que MaPrimeRénov' 2026 ?",
    answer: "MaPrimeRénov' 2026 est un dispositif d'aide de l'État français pour la rénovation énergétique des logements. Il permet de financer jusqu'à 80% des travaux d'isolation, de chauffage et d'énergie renouvelable.",
  },
  {
    question: "Qui peut bénéficier de MaPrimeRénov' ?",
    answer: "Tous les propriétaires occupants et bailleurs peuvent en bénéficier, sous conditions de revenus. Le montant de l'aide varie selon votre catégorie de revenus : très modeste, modeste, intermédiaire ou supérieur.",
  },
  {
    question: "Quels travaux sont éligibles ?",
    answer: "L'isolation thermique par l'extérieur (ITE), les pompes à chaleur (PAC), les panneaux solaires (PV), et d'autres travaux de rénovation énergétique réalisés par des artisans certifiés RGE.",
  },
  {
    question: "Combien de temps dure la vérification ?",
    answer: "La vérification d'éligibilité en ligne prend environ 2 minutes. Vous obtenez immédiatement une estimation de vos aides et un score d'éligibilité.",
  },
  {
    question: "L'accompagnement est-il gratuit ?",
    answer: "Oui, la vérification d'éligibilité et l'accompagnement par un conseiller certifié RGE sont entièrement gratuits et sans engagement.",
  },
];

// Process steps
export const processSteps = [
  { step: '1', title: 'Vérification en ligne', desc: 'Répondez à quelques questions en 2 minutes pour connaître vos aides.' },
  { step: '2', title: 'Rappel sous 24h', desc: 'Un conseiller certifié RGE vous rappelle pour analyser votre projet.' },
  { step: '3', title: 'Visite technique', desc: 'Visite gratuite à domicile pour valider les travaux à réaliser.' },
  { step: '4', title: 'Travaux & aides', desc: 'Votre dossier est déposé, les travaux démarrent, vous recevez vos aides.' },
];

// Mock eligibility score calculator
export const calculateEligibility = (formData) => {
  let score = 45;
  if (['F', 'G'].includes(formData.dpe)) score += 30;
  else if (formData.dpe === 'E') score += 20;
  else if (formData.dpe === 'unknown') score += 10;
  if (formData.status === 'proprietaire') score += 10;
  if (formData.revenueRange === 'tres_modeste') score += 15;
  else if (formData.revenueRange === 'modeste') score += 10;
  else if (formData.revenueRange === 'intermediaire') score += 5;
  return Math.min(score, 95);
};

// Revenue ranges (official MaPrimeRénov' color coding)
export const revenueRanges = [
  { id: 'tres_modeste', label: 'Très modeste', range: 'Moins de 17 009 €', colorDot: 'bg-sky-500', textColor: 'text-sky-700', borderSel: 'border-sky-400', bgSel: 'bg-sky-50', tag: 'Aides maximales' },
  { id: 'modeste', label: 'Modeste', range: '17 009 € – 21 805 €', colorDot: 'bg-amber-400', textColor: 'text-amber-700', borderSel: 'border-amber-400', bgSel: 'bg-amber-50', tag: 'Aides importantes' },
  { id: 'intermediaire', label: 'Intermédiaire', range: '21 805 € – 30 549 €', colorDot: 'bg-violet-500', textColor: 'text-violet-700', borderSel: 'border-violet-400', bgSel: 'bg-violet-50', tag: 'Aides modérées' },
  { id: 'superieur', label: 'Supérieur', range: 'Plus de 30 549 €', colorDot: 'bg-rose-400', textColor: 'text-rose-600', borderSel: 'border-rose-300', bgSel: 'bg-rose-50', tag: 'Aides limitées' },
];

// DPE scale for visual selector
export const dpeScale = [
  { letter: 'A', color: '#319834', w: '28%', label: 'Excellent' },
  { letter: 'B', color: '#33cc33', w: '34%', label: 'Très bon' },
  { letter: 'C', color: '#a8cc33', w: '40%', label: 'Bon' },
  { letter: 'D', color: '#ffcc00', w: '46%', label: 'Moyen' },
  { letter: 'E', color: '#ff9933', w: '52%', label: 'Passoire', selectable: true },
  { letter: 'F', color: '#ff6633', w: '58%', label: 'Très énergivore', selectable: true },
  { letter: 'G', color: '#e3001b', w: '64%', label: 'Extrême', selectable: true },
];

// Category-specific project fields
export const categoryFields = {
  ITE: [
    { id: 'combles', type: 'cards', label: 'Isolation des combles également ?', options: [
      { value: 'oui', label: 'Oui', desc: 'Combles inclus' },
      { value: 'non', label: 'Non', desc: 'ITE seule' },
    ]},
    { id: 'surface_isoler', type: 'number', label: 'Surface à isoler (m²)', placeholder: 'Ex : 120', unit: 'm²' },
  ],
  PAC: [
    { id: 'chauffage_actuel', type: 'cards', label: 'Votre chauffage actuel ?', options: [
      { value: 'fioul', label: 'Fioul', desc: 'Chaudière fioul' },
      { value: 'gaz', label: 'Gaz', desc: 'Chaudière gaz' },
      { value: 'electrique', label: 'Électrique', desc: 'Convecteurs' },
      { value: 'autre', label: 'Autre', desc: 'Autre système' },
    ]},
    { id: 'surface_chauffee', type: 'number', label: 'Surface chauffée (m²)', placeholder: 'Ex : 100', unit: 'm²' },
  ],
  PV: [
    { id: 'surface_toiture', type: 'number', label: 'Surface toiture disponible (m²)', placeholder: 'Ex : 40', unit: 'm²' },
    { id: 'ombrage', type: 'cards', label: 'Ombrage sur votre toiture ?', options: [
      { value: 'aucun', label: 'Aucun', desc: 'Plein soleil' },
      { value: 'partiel', label: 'Partiel', desc: 'Ombrage léger' },
      { value: 'important', label: 'Important', desc: 'Ombre fréquente' },
    ]},
  ],
};

// ── Additional qualification fields ────────────────────────

export const ageRanges = [
  { value: '18-25', label: '18 – 25 ans' },
  { value: '26-35', label: '26 – 35 ans' },
  { value: '36-45', label: '36 – 45 ans' },
  { value: '46-55', label: '46 – 55 ans' },
  { value: '56-65', label: '56 – 65 ans' },
  { value: '65+', label: 'Plus de 65 ans' },
];

export const employmentOptions = [
  { value: 'salarie', label: 'Salarié(e)', desc: 'CDI, CDD, intérim' },
  { value: 'independant', label: 'Indépendant(e)', desc: 'Auto-entrepreneur, libéral' },
  { value: 'retraite', label: 'Retraité(e)', desc: '' },
  { value: 'fonctionnaire', label: 'Fonctionnaire', desc: 'Fonction publique' },
  { value: 'sans_emploi', label: 'Sans emploi', desc: '' },
];

export const householdSizes = [
  { value: '1', label: '1 personne' },
  { value: '2', label: '2 personnes' },
  { value: '3', label: '3 personnes' },
  { value: '4', label: '4 personnes' },
  { value: '5+', label: '5 ou plus' },
];

export const housingTypes = [
  { value: 'maison', label: 'Maison', desc: 'Individuelle' },
  { value: 'appartement', label: 'Appartement', desc: 'Copropriété' },
];

export const constructionYears = [
  { value: 'before_1975', label: 'Avant 1975', desc: 'Éligibilité maximale' },
  { value: '1975-1990', label: '1975 – 1990', desc: '' },
  { value: '1990-2005', label: '1990 – 2005', desc: '' },
  { value: 'after_2005', label: 'Après 2005', desc: '' },
];

export const timelineOptions = [
  { value: 'urgent', label: 'Moins de 3 mois', desc: 'Projet urgent' },
  { value: '3-6', label: '3 à 6 mois', desc: '' },
  { value: '6-12', label: '6 à 12 mois', desc: '' },
  { value: '12+', label: 'Plus de 12 mois', desc: 'En réflexion' },
];

export const callbackTimes = [
  { value: 'matin', label: 'Matin', desc: '9h – 12h' },
  { value: 'apres_midi', label: 'Après-midi', desc: '14h – 17h' },
  { value: 'soir', label: 'Soir', desc: '17h – 19h' },
];

// Estimated aid calculator
export const estimateAid = (formData, categoryId) => {
  const rev = formData.revenueRange;
  const dpe = formData.dpe;
  if (!rev || !dpe) return null;

  const base = {
    ITE: { tres_modeste: { min: 90, max: 110 }, modeste: { min: 75, max: 90 }, intermediaire: { min: 40, max: 60 }, superieur: { min: 15, max: 25 } },
    PAC: { tres_modeste: { min: 10000, max: 15000 }, modeste: { min: 8000, max: 11000 }, intermediaire: { min: 4000, max: 6000 }, superieur: { min: 0, max: 2000 } },
    PV:  { tres_modeste: { min: 2500, max: 4000 }, modeste: { min: 2000, max: 3500 }, intermediaire: { min: 1500, max: 2500 }, superieur: { min: 1000, max: 1500 } },
  };

  const range = base[categoryId]?.[rev];
  if (!range) return null;

  let multiplier = 1;
  if (['F', 'G'].includes(dpe)) multiplier = 1.2;
  else if (dpe === 'unknown') multiplier = 0.9;

  const min = Math.round(range.min * multiplier);
  const max = Math.round(range.max * multiplier);

  if (categoryId === 'ITE') {
    const surface = parseInt(formData.surface_isoler) || 100;
    return { min: min * surface, max: max * surface, unit: '€', perUnit: `${min}–${max} €/m²` };
  }
  return { min, max, unit: '€', perUnit: null };
};

